import React from "react";
import { View, StyleSheet } from "react-native";
import ThemedInput from "@/components/ThemedInput";
import { Skeleton } from "@/components/ui/Skeleton";

export type AddressData = {
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
};

export interface AddressEditorProps {
  address?: AddressData;
  onChange?: (address: AddressData) => void;
  editing?: boolean;
  loading?: boolean;
}

export function AddressEditor({ address, onChange, editing = false, loading = false }: AddressEditorProps) {
  const disabled = loading || !editing;

  if (loading) {
    return (
      <View style={styles.container}>
        <Skeleton width="100%" height={40} />
        <View style={styles.row}>
          <Skeleton width="50%" height={40} />
          <Skeleton width="25%" height={40} />
          <Skeleton width="25%" height={40} />
        </View>
      </View>
    );
  }

  const handleUpdate = (field: keyof AddressData, value: string) => {
    if (editing) {
      onChange?.({ ...address, [field]: value });
    }
  };

  return (
    <View style={styles.container}>
      <ThemedInput
        label="Street"
        value={address?.street || ""}
        onChangeText={(text) => handleUpdate("street", text)}
        editable={!disabled}
        placeholder={disabled ? "—" : "Street address"}
      />
      <View style={styles.row}>
        <ThemedInput
          label="City"
          value={address?.city || ""}
          onChangeText={(text) => handleUpdate("city", text)}
          editable={!disabled}
          placeholder={disabled ? "—" : "City"}
          style={{ flex: 2 }}
        />
        <ThemedInput
          label="State"
          value={address?.state || ""}
          onChangeText={(text) => handleUpdate("state", text)}
          editable={!disabled}
          placeholder={disabled ? "—" : "State"}
          style={{ flex: 1 }}
        />
        <ThemedInput
          label="ZIP"
          value={address?.zip || ""}
          onChangeText={(text) => handleUpdate("zip", text)}
          editable={!disabled}
          placeholder={disabled ? "—" : "ZIP"}
          style={{ flex: 1 }}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  row: {
    flexDirection: "row",
    gap: 8,
  },
});
